module.exports = __webpack_public_path__ + "img/41.d7128e2d.svg";